document.addEventListener('DOMContentLoaded', function () {
    var popupOverlay = document.getElementById('enrollmentPopupOverlay');
    var closeBtn = document.getElementById('enrollmentPopupClose');

    // 'student' = new user (all 4 tabs visible), 'program' = returning student (only payment tab active)
    var enrollmentType = (popupOverlay && popupOverlay.getAttribute('data-enrollment-type')) || 'program';

    // 'course' (default) submits with program/payment fields on the Payment
    // tab; 'subscription' (/payment/subscribe) has no Payment tab — the
    // Proof (KYC) stage is final and submits to the subscription endpoint.
    var enrollmentContext = (popupOverlay && popupOverlay.getAttribute('data-enrollment-context')) || 'course';
    var finalStageId = enrollmentContext === 'subscription' ? 'proof-details-form' : 'payment-details-form';

    function paymentBtnLabel() {
        if (enrollmentContext === 'subscription') return 'Submit';
        return enrollmentType === 'student' ? 'Submit' : 'Pay Now';
    }

    // Delegated handler — the enroll button can be re-rendered/reclassed asynchronously
    // by course-idv.js after the API response, so a direct binding at DOMContentLoaded
    // misses any element that wasn't `.enroll-now` at first paint.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.enroll-card__btn.enroll-now');
        if (!btn || !popupOverlay) return;
        e.preventDefault();
        popupOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';

        var activeTab = document.querySelector('.enrollment-popup__tab.active');
        var nextBtn = document.getElementById('enrollmentPopupNext');
        if (activeTab && nextBtn) {
            if (activeTab.getAttribute('data-target') === finalStageId) {
                nextBtn.textContent = paymentBtnLabel();
            } else {
                nextBtn.textContent = 'Next';
            }
        }
        updatePayNowStatus();
    });

    // Close button
    if (closeBtn && popupOverlay) {
        closeBtn.addEventListener('click', function () {
            popupOverlay.classList.remove('active');
            document.body.style.overflow = '';
        });
    }

    // Click outside to close
    window.addEventListener('click', function (e) {
        if (e.target === popupOverlay) {
            popupOverlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    });

    // Custom select dropdowns
    var customSelects = document.querySelectorAll('.enrollment-popup__custom-select');

    customSelects.forEach(function (select) {
        var trigger = select.querySelector('.enrollment-popup__select-trigger');
        var options = select.querySelectorAll('.enrollment-popup__option');
        var hiddenInput = select.querySelector('input[type="hidden"]');

        trigger.addEventListener('click', function (e) {
            e.stopPropagation();

            // Close other selects
            customSelects.forEach(function (other) {
                if (other !== select) other.classList.remove('open');
            });

            select.classList.toggle('open');
        });

        options.forEach(function (option) {
            option.addEventListener('click', function (e) {
                e.stopPropagation();
                var value = this.getAttribute('data-value');
                var label = this.textContent.trim();

                trigger.querySelector('span').textContent = label;
                if (hiddenInput) {
                    hiddenInput.value = value;
                    if(typeof updatePayNowStatus === 'function') updatePayNowStatus();
                }

                // Clear this field's inline error as soon as a value is picked.
                clearGroupError(select.closest('.enrollment-popup__group'));

                options.forEach(function (opt) { opt.classList.remove('selected'); });
                this.classList.add('selected');

                select.classList.remove('open');
            });
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function () {
        customSelects.forEach(function (select) { select.classList.remove('open'); });
    });

    // Tab switching logic
    var tabs = document.querySelectorAll('.enrollment-popup__tab');
    var forms = document.querySelectorAll('.enrollment-popup__form');

    tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
            // Prevent clicking completed tabs
            if(this.classList.contains('completed')) return;

            var targetId = this.getAttribute('data-target');
            if(targetId) {
                // Remove active from all tabs
                tabs.forEach(function(t) { t.classList.remove('active'); });
                // Add active to clicked
                this.classList.add('active');

                // Hide all forms
                forms.forEach(function(form) { form.style.display = 'none'; });
                // Show target form
                var targetForm = document.getElementById(targetId);
                var nextBtn = document.getElementById('enrollmentPopupNext');
                if(targetForm) {
                    targetForm.style.display = '';
                    if(nextBtn) {
                        if(targetId === finalStageId) {
                            nextBtn.textContent = paymentBtnLabel();
                        } else {
                            nextBtn.textContent = 'Next';
                            nextBtn.disabled = false;
                            nextBtn.style.opacity = '1';
                            nextBtn.style.cursor = 'pointer';
                        }
                        // Always trigger validation status
                        updatePayNowStatus();
                    }
                }
            }
        });
    });

    // Form validation for the final-stage button (Pay Now / Submit)
    window.updatePayNowStatus = function() {
        console.log("Updating Pay Now status...");
        var finalForm = document.getElementById(finalStageId);
        var nextBtn = document.getElementById('enrollmentPopupNext');
        if (!finalForm || !nextBtn) return;

        var currentTab = document.querySelector('.enrollment-popup__tab.active');
        // Only run validation when specifically on the final stage
        if(!currentTab || currentTab.getAttribute('data-target') !== finalStageId) {
            return;
        }

        // "How do you know us" only exists on the course payment tab.
        var howKnowUsInput = finalForm.querySelector('input[name="how_know_us"]');
        var howKnowUs = enrollmentContext === 'subscription'
            ? 'n/a'
            : (howKnowUsInput ? howKnowUsInput.value : '');

        var policyAgreeInput = finalForm.querySelector('input[name="policy_agree"]');
        var policyAgree = policyAgreeInput ? policyAgreeInput.checked : false;
        
        var recaptchaResponse = '';
        var recaptchaWidget = document.querySelector('.g-recaptcha');
        
        // If reCAPTCHA exists and we have a sitekey, check response.
        if (recaptchaWidget && typeof recaptchaSiteKey !== 'undefined' && recaptchaSiteKey !== '') {
            try {
                if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.getResponse === 'function') {
                    recaptchaResponse = grecaptcha.getResponse();
                }
            } catch (e) {
                console.error('reCAPTCHA error:', e);
            }
        } else {
            console.warn('reCAPTCHA skipped because sitekey is missing or widget not present');
            recaptchaResponse = 'skipped';
        }
        
        console.log("Fields:", { howKnowUs: howKnowUs, policyAgree: policyAgree, recaptchaResponse: recaptchaResponse });

        if (howKnowUs && policyAgree && recaptchaResponse) {
            nextBtn.disabled = false;
            nextBtn.style.opacity = '1';
            nextBtn.style.cursor = 'pointer';
        } else {
            nextBtn.disabled = true;
            nextBtn.style.opacity = '0.5';
            nextBtn.style.cursor = 'not-allowed';
        }
    }

    var finalStageForm = document.getElementById(finalStageId);
    if(finalStageForm) {
        finalStageForm.querySelectorAll('input, select, textarea').forEach(function(input) {
            input.addEventListener('input', updatePayNowStatus);
            input.addEventListener('change', updatePayNowStatus);
        });
    }

    // ------------------------------------------------------------------
    // Payment Details — dynamic binding driven by /api/program/course-idv
    // + /api/program/estimation. Ported from the legacy enrollform.js flow
    // documented in instruction/04-api-and-content-architecture.md.
    // ------------------------------------------------------------------

    var paymentState = {
        program: null,          // slug, e.g. SNA-PRG-00010
        programName: '',        // human-readable name
        basePrice: 0,
        maxTurns: 1,
        isLoggedIn: false,
        estimationAbort: null
    };

    var paymentTurnLabels = {
        1: 'Single Payment',
        2: 'EMI Payment in 2 Parts',
        3: 'EMI Payment in 3 Parts',
        4: 'EMI Payment in 4 Parts',
        5: 'EMI Payment in 5 Parts'
    };
    var paymentTurnKeys = {
        1: 'Single Term',
        2: 'Dual Term',
        3: 'Triple Term',
        4: 'Four Term',
        5: 'Five Term'
    };

    function formatInr(value) {
        var num = Number(value) || 0;
        var isNeg = num < 0;
        var abs = Math.abs(num);
        var formatted = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(abs);
        return (isNeg ? '- ₹' : '₹') + formatted;
    }

    function escapeHtml(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function renderPaymentOptions() {
        var group = document.getElementById('payment-type-group');
        if (!group) return;

        var maxTurns = Math.max(1, Math.min(5, Number(paymentState.maxTurns) || 1));
        var basePrice = Number(paymentState.basePrice) || 0;

        var html = '';
        for (var i = 1; i <= maxTurns; i++) {
            var installment = basePrice / i;
            html += ''
                + '<div class="enrollment-popup__payment-card' + (i === 1 ? ' active' : '') + '" '
                +      'data-turn-key="' + paymentTurnKeys[i] + '" '
                +      'data-turn-label="' + escapeHtml(paymentTurnLabels[i]) + '">'
                +   '<div class="enrollment-popup__payment-radio"><div class="radio-dot"></div></div>'
                +   '<div class="enrollment-popup__payment-info">'
                +     '<span class="payment-name">' + escapeHtml(paymentTurnLabels[i]) + '</span>'
                +     '<span class="payment-amount">' + formatInr(installment) + '</span>'
                +   '</div>'
                + '</div>';
        }
        group.innerHTML = html;
        group.removeAttribute('data-loading');

        var hidden = document.getElementById('payment-option-input');
        if (hidden) hidden.value = paymentTurnKeys[1];

        // Bind clicks
        group.querySelectorAll('.enrollment-popup__payment-card').forEach(function (card) {
            card.addEventListener('click', function () {
                group.querySelectorAll('.enrollment-popup__payment-card').forEach(function (c) {
                    c.classList.remove('active');
                });
                card.classList.add('active');
                if (hidden) hidden.value = card.getAttribute('data-turn-key') || '';
                updateSummaryPaymentType();
                requestEstimation();
            });
        });

        // Seed the summary card with base numbers so the UX isn't blank before the
        // estimation call resolves (or when the user isn't logged in yet).
        seedBaseSummary();
    }

    function updateSummaryPaymentType() {
        var activeCard = document.querySelector('#payment-type-group .enrollment-popup__payment-card.active');
        var label = activeCard ? (activeCard.getAttribute('data-turn-label') || '') : '';
        var el = document.getElementById('summary-payment-type');
        if (el) el.textContent = label || '—';
    }

    function seedBaseSummary() {
        var base = Number(paymentState.basePrice) || 0;
        // 18% GST is applied on top of tuition per the legacy calc in enrollform.js L429.
        var withTax = Math.round(base + (base * 18 / 100));
        var tuitionEl = document.getElementById('summary-tuition-fee');
        var totalEl   = document.getElementById('summary-total-amount');
        if (tuitionEl) tuitionEl.textContent = formatInr(base);
        if (totalEl)   totalEl.textContent   = formatInr(withTax);
        updateSummaryPaymentType();
    }

    function applyEstimation(data) {
        if (!data || !data.summary) return;
        var tuitionEl = document.getElementById('summary-tuition-fee');
        var totalEl   = document.getElementById('summary-total-amount');
        if (tuitionEl) tuitionEl.textContent = formatInr(data.summary.tuitionFee);
        if (totalEl)   totalEl.textContent   = formatInr(data.summary.totalAmount);

        // Mirror the legacy textarea blob used by the submit handler
        var blob = document.getElementById('payment-estimation-blob');
        if (blob && Array.isArray(data.installments)) {
            var text = '';
            data.installments.forEach(function (group) {
                group.forEach(function (line) { text += line.name + ': ' + line.amount + '\n'; });
                text += '\n';
            });
            blob.value = text;
        }
        updateSummaryPaymentType();
    }

    function currentReferral() {
        var opt  = document.querySelector('input[name="referral_option"]');
        var code = document.getElementById('referral-code-input');
        return {
            option: opt ? (opt.value || 'I have none') : 'I have none',
            code:   code ? code.value.trim() : ''
        };
    }

    function requestEstimation() {
        if (!paymentState.program || !paymentState.isLoggedIn) return;

        var hidden = document.getElementById('payment-option-input');
        var paymentOption = hidden ? hidden.value : '';
        if (!paymentOption) return;

        var referral = currentReferral();
        var needsCode = referral.option === 'Use Student Referral Code' || referral.option === 'Use Coupon';
        if (needsCode && !referral.code) return;

        var params = new URLSearchParams();
        params.set('program', paymentState.program);
        params.set('payment_option', paymentOption);
        params.set('referral_option', referral.option);
        if (referral.option === 'Use Coupon' && referral.code)                params.set('coupon', referral.code);
        if (referral.option === 'Use Student Referral Code' && referral.code) params.set('referral_code', referral.code);

        if (paymentState.estimationAbort) paymentState.estimationAbort.abort();
        paymentState.estimationAbort = new AbortController();

        fetch('/api/program/estimation?' + params.toString(), {
            credentials: 'same-origin',
            signal: paymentState.estimationAbort.signal
        })
            .then(function (r) { return r.json(); })
            .then(function (result) {
                if (!result || !result.success) {
                    console.warn('Estimation error:', result && result.message);
                    return;
                }
                if (result.data && result.data.validity && result.data.validity.is_valid === false) {
                    console.warn('Estimation invalid:', result.data.validity.error);
                    return;
                }
                applyEstimation(result.data);
            })
            .catch(function (err) {
                if (err && err.name === 'AbortError') return;
                console.error('Estimation fetch failed:', err);
            });
    }

    function bindReferralHandlers() {
        var referralSelect  = document.getElementById('referral-option-select');
        var referralCodeBox = document.getElementById('referral-code-group');
        var referralCodeInp = document.getElementById('referral-code-input');
        if (!referralSelect) return;

        referralSelect.querySelectorAll('.enrollment-popup__option').forEach(function (opt) {
            opt.addEventListener('click', function () {
                var value = opt.getAttribute('data-value') || 'I have none';
                var needsCode = value === 'Use Student Referral Code' || value === 'Use Coupon';
                if (referralCodeBox) referralCodeBox.style.display = needsCode ? '' : 'none';
                if (!needsCode && referralCodeInp) referralCodeInp.value = '';
                // Defer so the hidden input has been set by the generic select handler above.
                setTimeout(requestEstimation, 0);
            });
        });

        if (referralCodeInp) {
            var debounced = null;
            referralCodeInp.addEventListener('input', function () {
                clearTimeout(debounced);
                debounced = setTimeout(requestEstimation, 350);
            });
        }
    }

    function bindCourseLoaded(data) {
        if (!data || !data.programDetails) return;
        var p = data.programDetails;

        paymentState.program     = p.program_name || p.name || '';
        paymentState.programName = p.program_name || '';
        paymentState.basePrice   = Number(p.price) || 0;
        paymentState.maxTurns    = Number(p.maximum_turns) || 1;
        paymentState.isLoggedIn  = Boolean(data.isLoggedIn);

        var nameInput = document.getElementById('payment-course-name');
        if (nameInput) nameInput.value = paymentState.programName;

        renderPaymentOptions();

        if (paymentState.isLoggedIn) requestEstimation();
    }

    // ------------------------------------------------------------------
    // Inline validation — red border + a message under each offending field,
    // on the spot (matches the My Account / Personal Info validation style).
    // ------------------------------------------------------------------
    function groupLabelText(group) {
        var label = group && group.querySelector('label');
        if (!label) return 'This field';
        var clone = label.cloneNode(true);
        var req = clone.querySelector('.required');
        if (req) req.remove();
        var text = (clone.textContent || '').replace(/\s+/g, ' ').trim();
        return text || 'This field';
    }

    function clearGroupError(group) {
        if (!group) return;
        group.classList.remove('enrollment-popup__group--invalid');
        var msg = group.querySelector('.enrollment-popup__field-error');
        if (msg) msg.remove();
    }

    function markGroupInvalid(group, message) {
        if (!group) return;
        group.classList.add('enrollment-popup__group--invalid');
        var msg = group.querySelector('.enrollment-popup__field-error');
        if (!msg) {
            msg = document.createElement('p');
            msg.className = 'enrollment-popup__field-error';
            msg.setAttribute('role', 'alert');
            group.appendChild(msg);
        }
        msg.textContent = message || (groupLabelText(group) + ' is required');
    }

    // Validate every required + visible group inside a stage. true == all good.
    function validateStage(formEl) {
        if (!formEl) return true;
        var firstInvalid = null;
        var groups = formEl.querySelectorAll('.enrollment-popup__group');
        Array.prototype.forEach.call(groups, function (group) {
            if (group.offsetParent === null) return;                 // skip hidden groups
            var label = group.querySelector('label');
            if (!label || !label.querySelector('.required')) return; // not required
            var controls = group.querySelectorAll('input[name], textarea[name], select[name]');
            if (!controls.length) return;
            var empty = false;
            Array.prototype.forEach.call(controls, function (c) {
                if (c.type === 'checkbox') { if (!c.checked) empty = true; return; }
                if (c.type === 'file')     { if (!(c.files && c.files.length)) empty = true; return; }
                if (!String(c.value || '').trim()) empty = true;
            });
            if (empty) {
                markGroupInvalid(group);
                if (!firstInvalid) firstInvalid = group;
            } else {
                clearGroupError(group);
            }
        });
        if (firstInvalid && firstInvalid.scrollIntoView) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return !firstInvalid;
    }

    // Activate a given stage (used to jump back to the first server error).
    function switchToStage(stageId) {
        var allTabs  = document.querySelectorAll('.enrollment-popup__tab');
        var allForms = document.querySelectorAll('.enrollment-popup__form');
        Array.prototype.forEach.call(allTabs,  function (t) { t.classList.remove('active'); });
        Array.prototype.forEach.call(allForms, function (f) { f.style.display = 'none'; });
        var tab = document.querySelector('.enrollment-popup__tab[data-target="' + stageId + '"]');
        if (tab) { tab.classList.add('active'); tab.classList.remove('completed'); }
        var form = document.getElementById(stageId);
        if (form) form.style.display = '';
        var nb = document.getElementById('enrollmentPopupNext');
        if (nb) nb.textContent = (stageId === finalStageId) ? paymentBtnLabel() : 'Next';
    }

    // Map a server { fieldName: message } object onto the form: red border +
    // message, and jump to the stage holding the first error. true if it mapped.
    function applyFieldErrors(fieldErrors) {
        if (!fieldErrors || typeof fieldErrors !== 'object') return false;
        var marked = [];
        var firstGroup = null;
        var firstStageId = null;
        Object.keys(fieldErrors).forEach(function (key) {
            var control = document.querySelector('.enrollment-popup__form [name="' + key + '"]');
            if (!control) return;
            var group = control.closest('.enrollment-popup__group');
            if (!group || marked.indexOf(group) !== -1) return;
            marked.push(group);
            var serverMsg = fieldErrors[key];
            var message = (!serverMsg || /_/.test(serverMsg))
                ? (groupLabelText(group) + ' is required')
                : serverMsg;
            markGroupInvalid(group, message);
            if (!firstGroup) {
                firstGroup = group;
                var stageForm = control.closest('.enrollment-popup__form');
                firstStageId = stageForm ? stageForm.id : null;
            }
        });
        if (!marked.length) return false;
        if (firstStageId) switchToStage(firstStageId);
        if (firstGroup && firstGroup.scrollIntoView) {
            firstGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return true;
    }

    // ------------------------------------------------------------------
    // "Next" / "Pay Now" button click handler
    // Navigates stages 1→2→3→4, then submits the enrollment on stage 4.
    // ------------------------------------------------------------------

    var nextBtn = document.getElementById('enrollmentPopupNext');
    if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
            e.preventDefault();

            var activeTab = document.querySelector('.enrollment-popup__tab.active');
            if (!activeTab) return;

            var currentTarget = activeTab.getAttribute('data-target');

            // If NOT on the final stage, advance to the next stage
            if (currentTarget !== finalStageId) {
                // On-the-spot validation: don't advance while required fields
                // on the current stage are empty — flag them inline instead.
                if (!validateStage(document.getElementById(currentTarget))) return;

                var allTabs = Array.prototype.slice.call(document.querySelectorAll('.enrollment-popup__tab'));
                var currentIdx = -1;
                for (var t = 0; t < allTabs.length; t++) {
                    if (allTabs[t] === activeTab) { currentIdx = t; break; }
                }
                if (currentIdx >= 0 && currentIdx < allTabs.length - 1) {
                    // Mark current tab as completed
                    activeTab.classList.remove('active');
                    activeTab.classList.add('completed');
                    if (!activeTab.querySelector('i.ri-check-line')) {
                        var icon = document.createElement('i');
                        icon.className = 'ri-check-line';
                        activeTab.appendChild(icon);
                    }

                    // Activate next tab
                    var nextTab = allTabs[currentIdx + 1];
                    nextTab.classList.add('active');
                    nextTab.classList.remove('completed');

                    // Toggle form visibility
                    var allForms = document.querySelectorAll('.enrollment-popup__form');
                    allForms.forEach(function (f) { f.style.display = 'none'; });
                    var nextFormId = nextTab.getAttribute('data-target');
                    var nextForm = document.getElementById(nextFormId);
                    if (nextForm) nextForm.style.display = '';

                    // Update button label
                    if (nextFormId === finalStageId) {
                        nextBtn.textContent = paymentBtnLabel();
                    } else {
                        nextBtn.textContent = 'Next';
                    }
                    updatePayNowStatus();
                }
                return;
            }

            // --- Final/submit stage ---
            if (nextBtn.disabled) return;

            // Subscription context: the Proof stage is the last one — validate
            // it (incl. required fields) before submitting.
            if (enrollmentContext === 'subscription'
                && !validateStage(document.getElementById(finalStageId))) {
                return;
            }

            // Prevent double-click
            nextBtn.disabled = true;
            var origText = nextBtn.textContent;
            nextBtn.textContent = 'Processing…';
            nextBtn.style.opacity = '0.6';
            nextBtn.style.cursor = 'wait';

            // Build FormData — fields shared by both enrollment paths
            var formData = new FormData();

            if (enrollmentContext !== 'subscription') {
                formData.append('program', paymentState.program || '');
                formData.append('academic_year', new Date().getFullYear().toString());

                // referral_option → have_referral_code
                var referralOpt = document.querySelector('input[name="referral_option"]');
                var referralVal = referralOpt ? referralOpt.value : 'I have none';
                formData.append('have_referral_code', referralVal);

                var referralCode = document.getElementById('referral-code-input');
                if (referralVal === 'Use Coupon' && referralCode && referralCode.value) {
                    formData.append('coupon', referralCode.value.trim());
                } else if (referralVal === 'Use Student Referral Code' && referralCode && referralCode.value) {
                    formData.append('student_referral_code', referralCode.value.trim());
                }

                // payment_option → turns
                var paymentOpt = document.getElementById('payment-option-input');
                formData.append('turns', paymentOpt ? paymentOpt.value : 'Single Term');

                // Estimation blob
                var estimationBlob = document.getElementById('payment-estimation-blob');
                formData.append('estimation', estimationBlob ? estimationBlob.value : '');
            }

            // reCAPTCHA
            var recaptchaResponse = '';
            try {
                if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.getResponse === 'function') {
                    recaptchaResponse = grecaptcha.getResponse();
                }
            } catch (err) { /* skip */ }
            formData.append('g-recaptcha-response', recaptchaResponse);

            var apiUrl;

            if (enrollmentType === 'student') {
                // Personal details
                ['first_name', 'last_name', 'student_email_id', 'country_code',
                 'student_mobile_number', 'telegram_username',
                 'dob_year', 'dob_month', 'dob_date', 'gender'
                ].forEach(function (name) {
                    var el = document.querySelector('[name="' + name + '"]');
                    if (el) formData.append(name, el.value);
                });

                // Education details
                ['education', 'institute_name', 'year_of_passing', 'occupation', 'college_course'
                ].forEach(function (name) {
                    var el = document.querySelector('[name="' + name + '"]');
                    if (el) formData.append(name, el.value);
                });

                // KYC details
                ['id_type', 'id_number', 'nationality',
                 'address_line_1', 'city', 'state', 'pincode', 'country'
                ].forEach(function (name) {
                    var el = document.querySelector('[name="' + name + '"]');
                    if (el) formData.append(name, el.value);
                });

                // ID proof file upload
                var fileInput = document.querySelector('input[name="custom_id_attachment_url"]');
                if (fileInput && fileInput.files && fileInput.files[0]) {
                    formData.append('custom_id_attachment_url', fileInput.files[0]);
                }

                if (enrollmentContext === 'subscription') {
                    apiUrl = '/api/student/subscription_enrollment';
                } else {
                    // how_know_us → reference (Studentenrollmentform field name)
                    var howKnowUsInput = document.querySelector('input[name="how_know_us"]');
                    formData.append('reference', howKnowUsInput ? howKnowUsInput.value : '');

                    apiUrl = '/api/student/enrollment';
                }
            } else {
                // Program enrollment only needs the email added explicitly
                var emailInput = document.querySelector('input[name="student_email_id"]');
                formData.append('student_email_id', emailInput ? emailInput.value : '');

                apiUrl = '/api/program/enrollment';
            }

            fetch(apiUrl, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData
            })
            .then(function (resp) {
                return resp.json().then(function (body) {
                    return { ok: resp.ok, status: resp.status, body: body };
                });
            })
            .then(function (result) {
                if (!result.ok || result.body.error || result.body.fieldErrors) {
                    // Per-field validation errors → render inline (red border +
                    // message), jumping to the stage with the first error.
                    var mapped = applyFieldErrors(result.body && result.body.fieldErrors);
                    if (!mapped) {
                        var errMsg = (result.body && result.body.error)
                            ? result.body.error
                            : 'Enrollment failed. Please try again.';
                        showEnrollmentNotification(errMsg, 'error');
                    }
                    try { if (typeof grecaptcha !== 'undefined') grecaptcha.reset(); } catch (ex) {}
                    return;
                }

                // Close popup on success
                var overlay = document.getElementById('enrollmentPopupOverlay');
                if (overlay) {
                    overlay.classList.remove('active');
                    document.body.style.overflow = '';
                }

                if (enrollmentContext === 'subscription') {
                    // Details saved on Student. Aadhaar → DigiLocker consent
                    // now; anything else → the checkout unlocks on reload.
                    var subData = (result.body && result.body.data) || {};
                    if (subData.consent_url) {
                        showSubscriptionKycModal(subData.consent_url);
                    } else if (subData.kyc_error) {
                        showEnrollmentNotification(
                            'Details saved. ' + subData.kyc_error, 'error');
                        setTimeout(function () { window.location.reload(); }, 2500);
                    } else {
                        showEnrollmentNotification(
                            'Enrollment details saved!', 'success');
                        setTimeout(function () { window.location.reload(); }, 1200);
                    }
                    return;
                }

                if (enrollmentType === 'student') {
                    // Student enrollment: show detailed success modal (KYC pending, no payment
                    // redirect). The chosen proof decides which next step it names.
                    var proofInput = document.querySelector('input[name="id_type"]');
                    showStudentSuccessModal(proofInput ? proofInput.value : '');
                } else {
                    // Program enrollment: redirect to payment page
                    showEnrollmentNotification(
                        'Application submitted! Redirecting to payment…',
                        'success'
                    );

                    var feeName   = result.body.fees_name;
                    var feeAmount = result.body.fees_amount;
                    var payUrl    = window.location.origin + '/payment/pay';
                    var params    = new URLSearchParams();
                    params.set('fee', feeName);
                    params.set('a', feeAmount);

                    setTimeout(function () {
                        window.open(payUrl + '?' + params.toString(), '_blank');
                    }, 600);
                }
            })
            .catch(function (err) {
                console.error('Enrollment request failed:', err);
                showEnrollmentNotification(
                    'Network error. Please check your connection and try again.',
                    'error'
                );
            })
            .finally(function () {
                nextBtn.textContent = origText;
                nextBtn.style.opacity = '1';
                nextBtn.style.cursor = 'pointer';
                updatePayNowStatus();
            });
        });
    }

    // Lightweight notification banner (avoids dependency on AlertModal)
    function showEnrollmentNotification(message, type) {
        var existing = document.getElementById('enrollment-notification');
        if (existing) existing.remove();

        var div = document.createElement('div');
        div.id = 'enrollment-notification';
        div.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);'
            + 'z-index:100000;padding:14px 28px;border-radius:8px;font-size:15px;'
            + 'font-weight:500;color:#fff;box-shadow:0 4px 20px rgba(0,0,0,0.3);'
            + 'transition:opacity 0.4s ease;max-width:90vw;text-align:center;';
        div.style.background = type === 'error' ? '#d9534f' : '#28a745';
        div.textContent = message;
        document.body.appendChild(div);

        setTimeout(function () {
            div.style.opacity = '0';
            setTimeout(function () { div.remove(); }, 500);
        }, 5000);
    }

    // Detailed success modal for student enrollment (matches legacy AlertModal pattern).
    // Uses Bootstrap Modal (bundled in app.js). Falls back to the toast if Bootstrap is absent.
    function showStudentSuccessModal(proofType) {
        // Self-contained overlay (inline styles, no Bootstrap dependency).
        var uid = 'enroll-success-modal';
        if (document.getElementById(uid)) return;

        // Only Aadhaar applicants are emailed a DigiLocker link; every other
        // proof is verified/reviewed in the back office and gets the
        // 'application received' note instead. Telling a PAN applicant to
        // wait for a DigiLocker mail that never arrives is what this avoids.
        var isAadhaar = String(proofType || '').trim().toLowerCase() === 'aadhar';
        var nextStep = isAadhaar
            ? 'Please check your email for <span style="color:#f97316;">DigiLocker verification</span> '
              + 'and verify using the Aadhaar you provided.'
            : 'Your application is <span style="color:#f97316;">under review</span>. '
              + "We've emailed you a confirmation and will let you know as soon as it's approved.";

        var check = '<svg width="38" height="38" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'
            + '<path d="M5 12.5l4.5 4.5L19 7.5" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        var overlay = document.createElement('div');
        overlay.id = uid;
        overlay.className = 'sna-modal';
        overlay.style.cssText = 'position:fixed;inset:0;z-index:100001;background:rgba(0,0,0,.7);'
            + 'display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit;';
        overlay.innerHTML =
            '<div class="sna-modal__card" style="position:relative;background-color:#141417;'
            +   'background-image:linear-gradient(90deg,transparent 0%,rgba(249,115,22,.1) 15%,rgba(249,115,22,.5) 30%,#f97316 50%,rgba(249,115,22,.5) 70%,rgba(249,115,22,.1) 85%,transparent 100%),linear-gradient(90deg,transparent 0%,rgba(249,115,22,.1) 15%,rgba(249,115,22,.5) 30%,#f97316 50%,rgba(249,115,22,.5) 70%,rgba(249,115,22,.1) 85%,transparent 100%);'
            +   'background-size:20% 2px,20% 2px;background-position:10% 0,90% 100%;background-repeat:no-repeat;'
            +   'border:1px solid #26262b;border-radius:24px;max-width:720px;width:100%;'
            +   'padding:48px 56px;text-align:center;box-shadow:0 24px 64px rgba(0,0,0,.55);">'
            +   '<button type="button" data-enroll-close aria-label="Close" style="position:absolute;top:18px;right:20px;'
            +     'background:none;border:none;cursor:pointer;color:#f97316;font-size:24px;line-height:1;padding:4px;">&times;</button>'
            +   '<div style="width:80px;height:80px;margin:0 auto 22px;border-radius:50%;background:#f97316;'
            +     'display:flex;align-items:center;justify-content:center;'
            +     'box-shadow:0 0 0 10px rgba(249,115,22,.10), 0 0 30px 6px rgba(249,115,22,.45);">' + check + '</div>'
            +   '<h3 style="font-size:30px;color:#fff;margin:0 0 14px;font-weight:600;">Application Submitted!</h3>'
            +   '<p style="font-size:15px;line-height:24px;color:#9a9aa2;margin:0 0 16px;">Hey Ninja! 🥷 Your enrolment '
            +     'has been received successfully.</p>'
            +   '<p style="font-size:15px;line-height:24px;color:#9a9aa2;margin:0 0 24px;">' + nextStep + '</p>'
            +   '<div style="height:1px;background:#26262b;margin:0 0 20px;"></div>'
            +   '<p style="font-size:13.5px;line-height:20px;color:#9a9aa2;margin:0 0 20px;">Need help? contact '
            +     '<a href="mailto:contact@selfmade.ninja" style="color:#f97316;text-decoration:none;">@selfmade.ninja</a> &bull; '
            +     '<a href="https://t.me/selfmadeninjasupport" target="_blank" style="color:#f97316;text-decoration:none;">@selfmadeninjasupport</a></p>'
            +   '<button type="button" data-enroll-close style="display:block;width:100%;'
            +     'background:linear-gradient(180deg,#fb8c3e 0%,#f97316 100%);color:#fff;font-size:15.5px;font-weight:700;'
            +     'padding:15px 0;border:none;border-radius:10px;cursor:pointer;box-shadow:0 6px 18px rgba(249,115,22,.35);">Got it!</button>'
            + '</div>';

        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
        function closeModal() { overlay.remove(); document.body.style.overflow = ''; }
        overlay.querySelectorAll('[data-enroll-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
        overlay.addEventListener('click', function (ev) { if (ev.target === overlay) closeModal(); });
    }

    // Subscription context: after the form saves, hand the student to
    // DigiLocker for Aadhaar consent (same design family as the success modal).
    function showSubscriptionKycModal(consentUrl) {
        var uid = 'subscription-kyc-modal';
        if (document.getElementById(uid)) return;

        var overlay = document.createElement('div');
        overlay.id = uid;
        overlay.className = 'sna-modal';
        overlay.style.cssText = 'position:fixed;inset:0;z-index:100001;background:rgba(0,0,0,.7);'
            + 'display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit;';
        overlay.innerHTML =
            '<div class="sna-modal__card" style="position:relative;background-color:#141417;border:1px solid #26262b;'
            +   'border-radius:24px;max-width:640px;width:100%;padding:44px 48px;text-align:center;'
            +   'box-shadow:0 24px 64px rgba(0,0,0,.55);">'
            +   '<h3 style="font-size:26px;color:#fff;margin:0 0 14px;font-weight:600;">Application Saved — Verify Your Aadhaar</h3>'
            +   '<p style="font-size:15px;line-height:24px;color:#9a9aa2;margin:0 0 24px;">One last step before checkout: '
            +     'verify your Aadhaar through <span style="color:#f97316;">DigiLocker</span>. '
            +     'You\'ll be redirected back here once it\'s done.</p>'
            +   '<a data-kyc-link style="display:block;width:100%;'
            +     'background:linear-gradient(180deg,#fb8c3e 0%,#f97316 100%);color:#fff;font-size:15.5px;font-weight:700;'
            +     'padding:15px 0;border:none;border-radius:10px;cursor:pointer;text-decoration:none;'
            +     'box-shadow:0 6px 18px rgba(249,115,22,.35);">Verify with DigiLocker</a>'
            +   '<p style="font-size:13px;color:#9a9aa2;margin:16px 0 0;">Lost this tab? You can restart the '
            +     'verification any time from the subscribe page.</p>'
            + '</div>';

        // href set via the DOM property (never string-built), https only.
        var link = overlay.querySelector('[data-kyc-link]');
        if (link && /^https:\/\//i.test(consentUrl)) {
            link.href = consentUrl;
        }

        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
    }

    // Clear a field's inline error the moment the user starts correcting it
    // (typing in a text input or toggling the file/checkbox).
    if (popupOverlay) {
        popupOverlay.addEventListener('input', function (e) {
            var grp = e.target.closest('.enrollment-popup__group');
            if (grp && grp.classList.contains('enrollment-popup__group--invalid')) clearGroupError(grp);
        });
        popupOverlay.addEventListener('change', function (e) {
            var grp = e.target.closest('.enrollment-popup__group');
            if (grp && grp.classList.contains('enrollment-popup__group--invalid')) clearGroupError(grp);
        });
    }

    // ID-proof upload (KYC): reflect the chosen file right on the upload button so
    // the user gets clear confirmation the attachment was picked — filled check +
    // filename, with a "Replace" affordance. See course/enrollment-popup.php.
    var idProofUpload = popupOverlay ? popupOverlay.querySelector('.enrollment-popup__file-upload') : null;
    if (idProofUpload) {
        var idProofInput = idProofUpload.querySelector('input[type="file"]');
        var idProofIcon = idProofUpload.querySelector('.enrollment-popup__file-icon');
        var idProofText = idProofUpload.querySelector('.enrollment-popup__file-text');
        var idProofDefaultText = idProofText ? idProofText.textContent.trim() : '';

        if (idProofInput) {
            idProofInput.addEventListener('change', function () {
                var file = idProofInput.files && idProofInput.files[0];
                if (file) {
                    idProofUpload.classList.add('enrollment-popup__file-upload--uploaded');
                    if (idProofIcon) idProofIcon.className = 'ri-checkbox-circle-fill enrollment-popup__file-icon';
                    if (idProofText) {
                        idProofText.textContent = file.name;
                        idProofText.setAttribute('title', file.name);
                    }
                } else {
                    idProofUpload.classList.remove('enrollment-popup__file-upload--uploaded');
                    if (idProofIcon) idProofIcon.className = 'ri-attachment-line enrollment-popup__file-icon';
                    if (idProofText) {
                        idProofText.textContent = idProofDefaultText;
                        idProofText.removeAttribute('title');
                    }
                }
            });
        }
    }

    bindReferralHandlers();
    document.addEventListener('course-idv:loaded', function (e) {
        bindCourseLoaded(e.detail);
    });
});
